import styled, { css } from "styled-components";

export const Label = styled.label`
  font-family: TitilliumWeb-Regular;
  font-size: 14px;
  line-height: 20px;
  color: #000;
  text-align: left;
  margin: 0px 0px 10px 0px;

  @media (min-width: 992px) {
    font-size: 16px;
    line-height: 1.25;
  }
`;
export const Select = styled.select`
  font-family: TitilliumWeb-Regular;
  max-width: 743px;
  height: 46px;
  width: 100%;
  height: 46px;
  border: 1px #212121 solid;
  border-radius: 23px;
  background-color: transparent;
  outline: 0;
  color: rgba(0, 0, 0, 0.8);
  padding: 10px;
  appearance: none;
  margin-right: 5px;
  background: url('data:image/svg+xml;utf-8,<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M7 10l5 5 5-5z"/><path d="M0 0h24v24H0z" fill="none"/></svg>')
    100% 50% no-repeat transparent;
`;
export const BoxSchool = styled.div`
  display: flex;
  justify-content: space-between;
  max-width: 396px;
`;
export const BoxOpt = styled.div``;
export const InputRadioOpt = styled.input`
  position: absolute;
  visibility: hidden;
  display: none;
  font-family: TitilliumWeb-Regular;

  &[checked] + .checkmarkinput {
    color: #ffffff;
    background-color: #0095d3;
    border: 1px solid #0095d3;
  }
  &[checked] + .checkmarkinput:after {
    display: block;
  }
`;
export const LabelRadioOpt = styled.label`
  font-family: TitilliumWeb-Regular;
  background-color: #ffffff;
  border: 1px solid #212121;
  border-radius: 25px;
  padding: 10px 35px;
  color: #212121;
  font-size: 16px;
  display: inline-block;
  cursor: pointer;

  @media (min-width: 375px) {
    padding: 10px 50px;
  }

  @media (min-width: 768px) {
    padding: 10px 66px;
  }
`;
export const BoxContentBoxFields = styled.div`
  margin-top: 5px;
  display: block !important;
  justify-content: left !important;
  text-align: left !important;

  @media (min-width: 768px) {
    justify-content: initial;
  }
`;
export const BoxContentBoxButtons = styled.div`
  display: flex;
  justify-content: center;
  margin: 16px auto;

  @media (min-width: 768px) {
    justify-content: initial;
  }
`;
export const BoxContentButton = styled.a`
  font-family: TitilliumWeb-Medium;
  font-size: 16px;
  color: #ffffff;
  white-space: nowrap;
  background-color: #21294f;
  height: 40px;
  width: 100%;
  border-radius: 24px;
  text-decoration: none;
  padding: 9px 40px;

  display: flex;
  justify-content: center;
  align-items: baseline;

  img {
    width: 17px;
    height: auto;
    margin-left: 7px;
  }
  &:hover {
    color: #ffffff;
    text-decoration: none;
  }
  & + a {
    margin-left: 17px;
    display: none;
  }
  @media (min-width: 768px) {
    width: unset;
  }
  @media (min-width: 1024px) {
    & + a {
      display: block;
    }
  }
`;
export const SectionExpansivel = styled.div`
  @media (min-width: 768px) {
    display: flex;
    text-align: center;
    border: solid 1px #d7d5d5;
    padding: 10px;
    flex-direction: column;
    align-items: center;
  }
`;
